import React, { useContext, useEffect } from 'react';
import Form from '../../..';
import TabInvoice from './TabFormInvoiceCreate';
import Tabs from '../../../../Tabs';
import * as S from '../styled';
import { ExportContext } from '../../../../../provider/ExportProvider';
import {
  defaultBlurInvoiceForm,
  defaultInvoiceForm,
} from '../../../../../store/invoice/utils';
import TabFormInvoiceTaxCreate from './TabFormInvoiceTaxCreate';
import { useSnackbar } from 'notistack';

export default function FormInvoiceCreate() {
  const {
    getInvoice,
    setInvoice,
    createInvoice,
    setModal,
    validateForm,
    filterInvoice,
    groups,
  } = useContext(ExportContext)!.controllers.invoice;

  const { enqueueSnackbar } = useSnackbar();

  const invoiceGroup = groups.invoice[0];

  const clearForm = () => {
    setInvoice(`forms.invoices.create`, {
      ...defaultInvoiceForm(),
      group: {
        id: invoiceGroup?.id ?? 0,
        number: invoiceGroup?.number ?? 0,
        name: invoiceGroup?.name ?? ''
      },
    });
    setInvoice(`blur.invoices.create`, defaultBlurInvoiceForm());
    setInvoice(`filters.selectTaxes.filter.filter`, []);
  };

  const [loading, setLoading] = React.useState(false);
  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    validateForm('invoices.create')
      .then(() => {
        setLoading(true);
        createInvoice()
          .then((invoice) => {
            enqueueSnackbar('Invoice criada com sucesso', {
              variant: 'success',
            });
            setInvoice('forms.invoices.create', defaultInvoiceForm());
            setInvoice(`blur.invoices.create`, defaultBlurInvoiceForm());
            setModal('single.createInvoice', false);
            setInvoice('filters.invoices.data.data', [
              ...getInvoice('filters.invoices.data.data'),
              invoice,
            ]);
            filterInvoice()
          })
          .catch(() => {
            enqueueSnackbar('Houve uma falha ao criar a invoice', {
              variant: 'error',
            });
          })
          .finally(() => {
            setLoading(false);
          });
      })
      .catch(() => {
        enqueueSnackbar('Verifique a validade dos campos', {
          variant: 'error',
        });
      });
  };

  return (
    <S.Form onSubmit={onSubmit}>
      <Tabs
        minHeight={'60vh'}
        maxHeight={'60vh'}
        style={{
          margin: '0 20px',
        }}
        items={[
          {
            label: 'INVOICE',
            children: <TabInvoice />,
          },
          {
            label: 'TAXAS',
            children: <TabFormInvoiceTaxCreate />,
          },
        ]}
      />
      <S.Actions>
        <Form.Button type="button" onClick={clearForm}>
          Limpar
        </Form.Button>
        <Form.Button loading={loading}>Criar</Form.Button>
      </S.Actions>
    </S.Form>
  );
}
